import { Swal, useHistory, AuthContext, clienteAxios } from "../../shared/";
import "../../shared/styles/UnifiedTable.css";

const Tabla = ({ data, puntoVenta, setSteps, steps }) => {
  const history = useHistory();


  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "editar":{
        history.push("/usuarios/editar/" + value.id);
      }
      break;
      case "cambiar_estado":{
        let formData = {
          user_id: parseInt(value.user.id),
          user_status: value.status
        };
        
        const response = await clienteAxios.post("/User/update", formData);
        setSteps(steps+1)  
        //
        Swal.fire({
          title: 'Usuario '+value.user.name+' Actualizado con exito',
        });

        
        window.location.reload()
      } break;
      case "cambiar_punto_venta":{
        let formData = {
          user_id: parseInt(value.user.id),
          user_punto_venta: value.punto_venta
        };
        
        const response = await clienteAxios.post("/User/update", formData);
        setSteps(steps+1)  
        //
        Swal.fire({
          title: 'Usuario '+value.user.name+' Actualizado con exito',
        });

        window.location.reload()
      } break;
    }
  }

  return (
    <div className="min-vh-100">
      <div className="unified-table-container">
        <table className="unified-table">
          <thead>
            <tr>
              <th className="text-center"><div>Id User</div></th>
              <th className="text-start"><div>Usuario</div></th>
              <th className="text-start"><div>Nombre y Apellido</div></th>
              <th className="text-start"><div>Email</div></th>
              <th className="text-center"><div>Rol</div></th>
              <th className="text-center"><div>Puntos de Venta</div></th>
              <th className="text-center"><div>Estado</div></th>
              <th className="text-center"><div>Acciones</div></th>
            </tr>
          </thead>
          <tbody>
            {data.map((user) => (
              <tr key={user.id}>
                <td className="text-center">{user.id}</td>
                <td className="text-start">{user.user_username}</td>
                <td className="text-start">{user.name + " " + user.lastname}</td>
                <td className="text-start">{user.email}</td>
                <td className="text-center">
                  <span className="unified-badge unified-badge-info">
                    {user.user_type}
                  </span>
                </td>
                <td className="text-center">
                  <div className="dropdown">
                    <button
                      className="unified-table-select"
                      type="button"
                      id={`dropdownPuntoVenta${user.id}`}
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {user.puntos_venta ? user.puntos_venta.nombre : "Sin punto de venta"}
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby={`dropdownPuntoVenta${user.id}`}
                    >
                      {puntoVenta
                        ? puntoVenta.map((venta, index) => (
                            <li key={index}>
                              <button
                                className="dropdown-item"
                                name="cambiar_punto_venta"
                                onClick={(event) =>
                                  onClick(event, { user: user, punto_venta: venta.id })
                                }
                              >
                                {venta.nombre}
                              </button>
                            </li>
                          ))
                        : null}
                    </ul>
                  </div>
                </td>
                <td className="text-center">
                  <div className="dropdown">
                    <button
                      className={`unified-badge ${
                        user.user_active == 1
                          ? 'unified-badge-success'
                          : 'unified-badge-danger'
                      }`}
                      type="button"
                      id={`dropdownEstado${user.id}`}
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      style={{ cursor: 'pointer', border: 'none' }}
                    >
                      {user.user_active == 1 ? "ACTIVO" : "INACTIVO"} ▼
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby={`dropdownEstado${user.id}`}
                    >
                      <li>
                        <button
                          className="dropdown-item"
                          name="cambiar_estado"
                          onClick={(event) =>
                            onClick(event, { user: user, status: 1 })
                          }
                        >
                          Activo
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item"
                          name="cambiar_estado"
                          onClick={(event) =>
                            onClick(event, { user: user, status: 0 })
                          }
                        >
                          Inactivo
                        </button>
                      </li>
                    </ul>
                  </div>
                </td>
                <td className="text-center">
                  <button
                    className="btn btn-sm"
                    style={{
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      color: '#ffffff',
                      borderRadius: '8px',
                      padding: '8px 16px',
                      border: 'none',
                      fontWeight: '500'
                    }}
                    name="editar"
                    onClick={(event) => onClick(event, user)}
                  >
                    <i className="bi bi-pencil-fill me-2"></i>
                    Editar
                  </button>
                </td>
            </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Tabla;
